export default __webpack_public_path__ + "static/media/daniele.d728f9c0.jpeg";